module.exports = __webpack_public_path__ + "static/media/1POLICY44.a52f5bf9.jpg";